export function useMobileDevice() {
  const isMobile = ref(false);

  function checkMobileDevice() {
    isMobile.value =
      /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(
        navigator.userAgent
      );
  }

  onMounted(() => {
    window.addEventListener('resize', checkMobileDevice);
    checkMobileDevice();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobileDevice);
  });

  return {
    isMobile,
  };
}
